//=====================================================
//　セレクトボックスベース
//=====================================================

import { useFormContext } from "react-hook-form"

interface IFProps {
    name: string,
    className: string,
    options: IFOption[],
    selectedIdx?: number,
    placeholder?: string,
    validations?: {}
}

interface IFOption {
    value: string,
    text: string
}

export function InputSelectBase(props: IFProps) {

    const cf = useFormContext();

    //クラス名設定。対象にエラーがある場合はis-errorを付与。
    let tmpClass = props.className;
    if (cf.formState.errors[props.name]){
        tmpClass = tmpClass + " is-error";
    }

    let selectedIdx = 0;
    if (props.selectedIdx){
        selectedIdx = props.selectedIdx;
    }

    return (
        <div className={"select-box " + tmpClass}>
            <select id={props.name} {...cf.register(props.name, props.validations)}>
                {props.options.map(function(val, idx){
                    let classVal = "";
                    if (selectedIdx === idx){
                        classVal="select-initial";
                    }
                    return (<option key={idx} value={val.value} className={classVal}>{val.text}</option>)
                })}
            </select>
        </div>
    )

}